var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoyYo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 28,
    viewBox: "0 0 249 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_154)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.96 88.17C174.73 88.95 174.41 89.61 173.99 90.14C173.57 90.67 173.11 91.1 172.58 91.42C172.06 91.75 171.51 91.98 170.93 92.12C170.35 92.26 169.78 92.33 169.23 92.33C168.32 92.33 167.47 92.21 166.68 91.98C165.89 91.74 165.2 91.35 164.63 90.79C164.05 90.24 163.59 89.5 163.26 88.59C162.93 87.68 162.76 86.55 162.76 85.22C162.76 84.96 162.78 84.62 162.82 84.19C162.86 83.77 162.95 83.31 163.1 82.82C163.25 82.33 163.46 81.84 163.74 81.34C164.02 80.84 164.39 80.39 164.85 80C165.31 79.6 165.88 79.27 166.56 79.02C167.24 78.77 168.05 78.64 168.99 78.64C169.63 78.64 170.3 78.73 171.02 78.92C171.74 79.11 172.4 79.47 173 80C173.6 80.53 174.1 81.26 174.5 82.19C174.9 83.12 175.1 84.33 175.1 85.81V86.42H166.18C166.2 86.66 166.24 86.97 166.3 87.32C166.36 87.68 166.5 88.03 166.7 88.37C166.9 88.71 167.21 89 167.6 89.24C168 89.48 168.54 89.59 169.23 89.59C169.7 89.59 170.15 89.47 170.59 89.24C171.02 89 171.3 88.65 171.43 88.18H174.95L174.96 88.17ZM171.59 84.18C171.54 83.66 171.43 83.22 171.25 82.87C171.07 82.52 170.86 82.24 170.61 82.03C170.37 81.82 170.1 81.67 169.8 81.58C169.51 81.49 169.22 81.45 168.94 81.45C168.12 81.45 167.5 81.69 167.07 82.17C166.64 82.65 166.37 83.32 166.28 84.19H171.59V84.18Z",
    fill: "#00329F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.9 91.98H185.55V90.34H185.5C185.08 91.07 184.52 91.59 183.84 91.88C183.16 92.17 182.45 92.32 181.74 92.32C180.78 92.32 179.95 92.12 179.26 91.73C178.57 91.34 178 90.82 177.56 90.17C177.12 89.52 176.79 88.77 176.58 87.93C176.37 87.09 176.26 86.22 176.26 85.33C176.26 84.21 176.41 83.22 176.7 82.38C176.99 81.54 177.39 80.84 177.89 80.29C178.39 79.74 178.96 79.32 179.61 79.04C180.26 78.76 180.95 78.62 181.66 78.62C182.21 78.62 182.69 78.69 183.1 78.82C183.51 78.95 183.86 79.12 184.16 79.32C184.46 79.52 184.71 79.74 184.92 79.98C185.12 80.22 185.29 80.44 185.42 80.65H185.47V74.42H188.89V91.97L188.9 91.98ZM179.78 85.57C179.78 85.96 179.82 86.39 179.91 86.84C180 87.3 180.15 87.72 180.36 88.11C180.57 88.5 180.86 88.83 181.22 89.1C181.58 89.37 182.03 89.5 182.59 89.5C183.15 89.5 183.59 89.39 183.97 89.18C184.35 88.97 184.67 88.69 184.91 88.35C185.15 88.01 185.33 87.61 185.45 87.16C185.56 86.71 185.62 86.24 185.62 85.75C185.62 85.23 185.57 84.72 185.49 84.22C185.4 83.72 185.25 83.28 185.03 82.89C184.81 82.5 184.51 82.18 184.14 81.94C183.76 81.7 183.28 81.57 182.7 81.57C182.16 81.57 181.71 81.68 181.33 81.9C180.95 82.12 180.65 82.42 180.43 82.79C180.2 83.17 180.04 83.59 179.94 84.07C179.84 84.55 179.79 85.04 179.79 85.55L179.78 85.57Z",
    fill: "#00329F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.27 88.17C202.04 88.95 201.72 89.61 201.3 90.14C200.88 90.67 200.42 91.1 199.89 91.42C199.37 91.75 198.82 91.98 198.24 92.12C197.66 92.26 197.09 92.33 196.54 92.33C195.63 92.33 194.78 92.21 193.99 91.98C193.2 91.74 192.51 91.35 191.94 90.79C191.36 90.24 190.9 89.5 190.57 88.59C190.24 87.68 190.07 86.55 190.07 85.22C190.07 84.96 190.09 84.62 190.13 84.19C190.17 83.77 190.26 83.31 190.41 82.82C190.56 82.33 190.77 81.84 191.05 81.34C191.33 80.84 191.7 80.39 192.16 80C192.62 79.6 193.19 79.27 193.87 79.02C194.55 78.77 195.36 78.64 196.3 78.64C196.94 78.64 197.61 78.73 198.33 78.92C199.05 79.11 199.71 79.47 200.31 80C200.91 80.53 201.41 81.26 201.81 82.19C202.21 83.12 202.41 84.33 202.41 85.81V86.42H193.49C193.51 86.66 193.55 86.97 193.61 87.32C193.67 87.68 193.81 88.03 194.01 88.37C194.21 88.71 194.52 89 194.91 89.24C195.31 89.48 195.85 89.59 196.54 89.59C197.01 89.59 197.46 89.47 197.9 89.24C198.33 89 198.61 88.65 198.74 88.18H202.26L202.27 88.17ZM198.9 84.18C198.85 83.66 198.74 83.22 198.56 82.87C198.38 82.52 198.17 82.24 197.92 82.03C197.68 81.82 197.41 81.67 197.11 81.58C196.82 81.49 196.53 81.45 196.25 81.45C195.43 81.45 194.81 81.69 194.38 82.17C193.95 82.65 193.68 83.32 193.59 84.19H198.9V84.18Z",
    fill: "#00329F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.16 80.66H207.21C207.34 80.45 207.51 80.22 207.71 79.99C207.91 79.75 208.17 79.53 208.47 79.33C208.77 79.13 209.13 78.96 209.53 78.83C209.94 78.7 210.42 78.63 210.97 78.63C211.69 78.63 212.37 78.77 213.02 79.05C213.67 79.33 214.25 79.74 214.74 80.3C215.24 80.85 215.63 81.55 215.93 82.39C216.22 83.23 216.37 84.21 216.37 85.34C216.37 86.24 216.26 87.1 216.05 87.94C215.84 88.78 215.51 89.53 215.07 90.18C214.63 90.83 214.06 91.35 213.37 91.74C212.68 92.13 211.85 92.33 210.89 92.33C210.17 92.33 209.47 92.18 208.79 91.89C208.11 91.6 207.55 91.08 207.13 90.35H207.08V91.99H203.73V74.44H207.15V80.67L207.16 80.66ZM212.86 85.57C212.86 85.07 212.81 84.57 212.71 84.09C212.61 83.61 212.45 83.18 212.22 82.81C211.99 82.44 211.69 82.14 211.32 81.92C210.94 81.7 210.49 81.59 209.95 81.59C209.36 81.59 208.88 81.71 208.5 81.96C208.12 82.2 207.82 82.52 207.6 82.91C207.38 83.3 207.23 83.75 207.15 84.24C207.07 84.74 207.03 85.25 207.03 85.77C207.03 86.26 207.09 86.73 207.2 87.18C207.31 87.63 207.49 88.02 207.74 88.37C207.98 88.71 208.3 88.99 208.68 89.2C209.06 89.41 209.52 89.52 210.06 89.52C210.6 89.52 211.07 89.39 211.43 89.12C211.79 88.85 212.07 88.52 212.29 88.13C212.5 87.74 212.65 87.32 212.74 86.86C212.83 86.4 212.87 85.98 212.87 85.59L212.86 85.57Z",
    fill: "#00329F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.95 89.44C228.95 90.21 229.02 90.72 229.17 90.98C229.32 91.24 229.5 91.4 229.71 91.47V91.98H226.02C225.97 91.83 225.93 91.7 225.9 91.59C225.87 91.48 225.84 91.37 225.81 91.26C225.79 91.15 225.76 91.04 225.75 90.91C225.73 90.78 225.72 90.63 225.7 90.45C225.5 90.65 225.28 90.86 225.04 91.09C224.8 91.32 224.51 91.52 224.17 91.7C223.84 91.88 223.45 92.03 223.02 92.15C222.59 92.27 222.08 92.33 221.49 92.33C221 92.33 220.52 92.26 220.05 92.12C219.58 91.98 219.15 91.76 218.78 91.45C218.4 91.14 218.1 90.75 217.88 90.26C217.65 89.78 217.54 89.2 217.54 88.54C217.54 87.88 217.63 87.35 217.82 86.87C218.01 86.39 218.27 85.98 218.61 85.64C218.95 85.3 219.36 85.02 219.82 84.82C220.28 84.62 220.79 84.47 221.32 84.39L224.4 83.93C224.66 83.9 224.93 83.81 225.19 83.67C225.46 83.53 225.59 83.28 225.59 82.9C225.59 82.52 225.51 82.26 225.36 82.06C225.21 81.86 225.02 81.71 224.8 81.61C224.58 81.51 224.34 81.45 224.07 81.43C223.8 81.41 223.56 81.39 223.35 81.39C222.93 81.39 222.58 81.45 222.31 81.56C222.04 81.67 221.83 81.82 221.69 82C221.54 82.18 221.44 82.38 221.37 82.59C221.3 82.8 221.26 83.01 221.25 83.2H217.95C218.05 82.21 218.28 81.41 218.65 80.8C219.02 80.2 219.47 79.74 220.01 79.42C220.55 79.1 221.14 78.89 221.79 78.8C222.44 78.7 223.1 78.65 223.77 78.65C224.23 78.65 224.75 78.7 225.35 78.78C225.94 78.87 226.51 79.05 227.05 79.32C227.59 79.59 228.04 79.97 228.41 80.47C228.78 80.97 228.96 81.62 228.96 82.41V89.45L228.95 89.44ZM225.6 85.65C225.42 85.78 225.17 85.9 224.84 86.02C224.51 86.13 223.99 86.25 223.28 86.36C222.95 86.41 222.65 86.47 222.38 86.56C222.1 86.64 221.86 86.75 221.65 86.89C221.44 87.03 221.27 87.21 221.15 87.44C221.03 87.67 220.97 87.96 220.97 88.32C220.97 88.61 221.02 88.86 221.13 89.07C221.24 89.27 221.37 89.44 221.52 89.56C221.67 89.68 221.85 89.77 222.03 89.82C222.22 89.87 222.39 89.89 222.56 89.89C222.93 89.89 223.31 89.83 223.67 89.71C224.04 89.59 224.36 89.42 224.65 89.2C224.93 88.98 225.17 88.71 225.35 88.39C225.53 88.07 225.62 87.72 225.62 87.33V85.67L225.6 85.65Z",
    fill: "#00329F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.42 91.98H239V84.08C239 83.84 238.99 83.57 238.96 83.27C238.93 82.97 238.85 82.7 238.7 82.44C238.55 82.18 238.33 81.96 238.03 81.78C237.73 81.6 237.31 81.51 236.77 81.51C236 81.51 235.36 81.76 234.85 82.27C234.34 82.78 234.08 83.53 234.08 84.52V91.98H230.66V78.97H233.94V80.88H233.99C234.1 80.68 234.25 80.46 234.44 80.2C234.63 79.94 234.88 79.69 235.19 79.47C235.5 79.24 235.87 79.05 236.31 78.88C236.75 78.72 237.28 78.64 237.9 78.64C238.52 78.64 239.13 78.73 239.68 78.92C240.23 79.11 240.71 79.38 241.11 79.75C241.51 80.12 241.83 80.57 242.06 81.11C242.3 81.65 242.41 82.28 242.41 82.99V91.99L242.42 91.98Z",
    fill: "#00329F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.51 91.21C161.4 91.07 161.33 90.88 161.28 90.62C161.23 90.37 161.2 90.03 161.19 89.61C161.19 89.19 161.18 88.66 161.18 88.02C161.18 87.21 161.13 86.55 161.03 86.04C160.93 85.54 160.79 85.12 160.6 84.81C160.41 84.49 160.18 84.25 159.9 84.08C159.62 83.91 159.3 83.74 158.95 83.58C159.83 83.29 160.5 82.76 160.97 82C161.43 81.24 161.67 80.37 161.67 79.4C161.67 79.03 161.6 78.56 161.46 77.99C161.32 77.43 161.05 76.88 160.65 76.35C160.25 75.82 159.69 75.37 158.98 74.99C158.26 74.62 157.32 74.43 156.14 74.43H145.57V74.46C147.63 76.79 148.89 79.86 148.89 83.22C148.89 86.58 147.63 89.65 145.57 91.98H150.86V85.11H154.65C155.33 85.11 155.87 85.17 156.25 85.29C156.63 85.41 156.92 85.61 157.11 85.88C157.3 86.15 157.41 86.49 157.45 86.91C157.49 87.33 157.51 87.84 157.51 88.44C157.51 89.35 157.54 90.07 157.61 90.58C157.67 91.09 157.77 91.56 157.9 91.99H161.96V91.53C161.76 91.47 161.61 91.36 161.51 91.22V91.21ZM157.3 81.61C156.84 81.97 156.12 82.15 155.16 82.15H150.86V77.46H155.43C155.97 77.46 156.4 77.54 156.74 77.69C157.07 77.85 157.33 78.04 157.52 78.26C157.71 78.49 157.83 78.74 157.9 79.01C157.96 79.28 158 79.53 158 79.76C158 80.64 157.77 81.26 157.3 81.62V81.61Z",
    fill: "#00329F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.29 80.44C248.29 81.52 247.42 82.38 246.32 82.38C245.22 82.38 244.33 81.52 244.33 80.44C244.33 79.36 245.21 78.52 246.33 78.52C247.45 78.52 248.29 79.36 248.29 80.44ZM244.82 80.44C244.82 81.3 245.47 81.98 246.33 81.98C247.16 81.98 247.8 81.3 247.8 80.45C247.8 79.6 247.16 78.9 246.31 78.9C245.46 78.9 244.83 79.59 244.83 80.44M246.02 81.44H245.57V79.51C245.75 79.49 245.99 79.45 246.31 79.45C246.67 79.45 246.84 79.51 246.97 79.61C247.09 79.69 247.17 79.83 247.17 80.02C247.17 80.25 246.99 80.41 246.77 80.48V80.5C246.96 80.56 247.05 80.71 247.11 80.97C247.17 81.26 247.22 81.37 247.25 81.44H246.78C246.72 81.37 246.69 81.21 246.63 80.97C246.59 80.77 246.48 80.68 246.23 80.68H246.02V81.44ZM246.03 80.36H246.24C246.48 80.36 246.69 80.28 246.69 80.08C246.69 79.9 246.56 79.79 246.28 79.79C246.17 79.79 246.08 79.79 246.04 79.81V80.36H246.03Z",
    fill: "#00329F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.84 94.86C134.44 94.95 135.05 95 135.67 95V83.62L133.84 84.67V94.86Z",
    fill: "url(#paint0_linear_318_154)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 94.09C131.69 94.34 132.3 94.53 132.93 94.68V85.2L131.1 86.25V94.09Z",
    fill: "url(#paint1_linear_318_154)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M128.36 92.48C128.93 92.93 129.54 93.32 130.19 93.66V86.78L128.36 87.83V92.48Z",
    fill: "url(#paint2_linear_318_154)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.66 95L136.01 94.8V83.42L135.66 83.22V95Z",
    fill: "url(#paint3_linear_318_154)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.93 94.68L133.27 94.48V85L132.92 85.2L132.93 94.68Z",
    fill: "url(#paint4_linear_318_154)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.19 93.66L130.53 93.46V86.58L130.18 86.78L130.19 93.66Z",
    fill: "url(#paint5_linear_318_154)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.83 90.62C145.21 90.15 145.55 89.65 145.86 89.11L136 83.42V85.53L144.82 90.63L144.83 90.62Z",
    fill: "url(#paint6_linear_318_154)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.79 92.61C143.3 92.22 143.77 91.8 144.22 91.33L136.01 86.59V88.7L142.8 92.62L142.79 92.61Z",
    fill: "url(#paint7_linear_318_154)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.03 94.1701C140.7 93.9001 141.35 93.5701 141.96 93.1801L136 89.7501V91.8501L140.03 94.1701Z",
    fill: "url(#paint8_linear_318_154)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.86 89.11V88.71L136.01 83.02L135.66 83.22L145.86 89.11Z",
    fill: "url(#paint9_linear_318_154)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.22 91.3201V90.9301L136 86.1801V86.59L144.22 91.3201Z",
    fill: "url(#paint10_linear_318_154)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.97 93.18V92.79L136 89.34V89.76L141.97 93.18Z",
    fill: "url(#paint11_linear_318_154)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.66 78.99C146.44 78.43 146.18 77.88 145.87 77.34L136.01 83.03L137.84 84.08L146.67 78.99H146.66Z",
    fill: "url(#paint12_linear_318_154)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.36 81.74C147.28 81.11 147.15 80.48 146.96 79.86L138.75 84.6L140.57 85.65L147.36 81.73V81.74Z",
    fill: "url(#paint13_linear_318_154)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.33 84.92C147.43 84.2 147.47 83.48 147.44 82.75L141.49 86.2L143.3 87.25L147.33 84.93V84.92Z",
    fill: "url(#paint14_linear_318_154)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.87 77.33L145.52 77.13L135.66 82.82L135.67 83.22L145.87 77.33Z",
    fill: "url(#paint15_linear_318_154)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.96 79.86L146.61 79.66L138.4 84.41L138.75 84.61L146.96 79.86Z",
    fill: "url(#paint16_linear_318_154)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M147.44 82.75L147.1 82.55L141.14 85.99L141.49 86.19L147.44 82.75Z",
    fill: "url(#paint17_linear_318_154)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M137.49 71.58C136.9 71.49 136.29 71.44 135.66 71.44V82.82L137.49 81.77V71.58Z",
    fill: "url(#paint18_linear_318_154)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M140.23 72.36C139.64 72.12 139.03 71.92 138.4 71.77V81.25L140.23 80.2V72.36Z",
    fill: "url(#paint19_linear_318_154)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M142.97 73.96C142.4 73.51 141.79 73.12 141.14 72.78V79.66L142.97 78.61V73.96Z",
    fill: "url(#paint20_linear_318_154)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.67 71.44L135.32 71.64V83.02L135.67 83.22V71.44Z",
    fill: "url(#paint21_linear_318_154)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M138.41 71.76L138.06 71.96V81.45L138.41 81.25V71.76Z",
    fill: "url(#paint22_linear_318_154)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.14 72.78L140.8 72.98V79.87L141.15 79.66L141.14 72.78Z",
    fill: "url(#paint23_linear_318_154)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 75.82C126.12 76.29 125.78 76.79 125.47 77.33L135.33 83.02V80.91L126.51 75.82H126.5Z",
    fill: "url(#paint24_linear_318_154)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M128.54 73.84C128.03 74.23 127.56 74.65 127.11 75.12L135.32 79.86V77.75L128.53 73.83L128.54 73.84Z",
    fill: "url(#paint25_linear_318_154)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.3 72.27C130.63 72.54 129.98 72.87 129.37 73.26L135.33 76.69V74.59L131.3 72.26V72.27Z",
    fill: "url(#paint26_linear_318_154)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M125.46 77.33V77.73L135.32 83.42L135.67 83.22L125.46 77.33Z",
    fill: "url(#paint27_linear_318_154)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M127.11 75.12V75.52L135.32 80.26V79.86L127.11 75.12Z",
    fill: "url(#paint28_linear_318_154)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M129.36 73.26V73.66L135.32 77.1V76.69L129.36 73.26Z",
    fill: "url(#paint29_linear_318_154)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M124.67 87.46C124.89 88.02 125.15 88.57 125.46 89.11L135.32 83.42L133.49 82.37L124.67 87.47V87.46Z",
    fill: "url(#paint30_linear_318_154)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M123.97 84.7C124.05 85.33 124.18 85.96 124.37 86.58L132.58 81.84L130.76 80.79L123.97 84.71V84.7Z",
    fill: "url(#paint31_linear_318_154)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124 81.53C123.9 82.25 123.86 82.97 123.89 83.7L129.84 80.25L128.02 79.2L123.99 81.52L124 81.53Z",
    fill: "url(#paint32_linear_318_154)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M125.46 89.11L125.81 89.31L135.66 83.62V83.22L125.46 89.11Z",
    fill: "url(#paint33_linear_318_154)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M124.37 86.58L124.71 86.78L132.93 82.04L132.58 81.84L124.37 86.58Z",
    fill: "url(#paint34_linear_318_154)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M123.89 83.7L124.23 83.9L130.19 80.46L129.84 80.25L123.89 83.7Z",
    fill: "url(#paint35_linear_318_154)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M125.27 88.75L125.46 89.08L135.32 83.41L134.98 83.22L125.27 88.75Z",
    fill: "url(#paint36_linear_318_154)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.26 86.19L124.36 86.55L132.58 81.82L132.23 81.63L124.26 86.19Z",
    fill: "url(#paint37_linear_318_154)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123.88 83.33V83.66L129.84 80.25L129.56 80.09L123.88 83.33Z",
    fill: "url(#paint38_linear_318_154)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.27 95L135.64 94.99L135.66 83.62L135.33 83.82L135.27 95Z",
    fill: "url(#paint39_linear_318_154)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M132.54 94.58L132.9 94.68L132.92 85.2L132.58 85.41L132.54 94.58Z",
    fill: "url(#paint40_linear_318_154)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.88 93.49L130.17 93.65L130.19 86.79L129.92 86.94L129.88 93.49Z",
    fill: "url(#paint41_linear_318_154)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.66 89.46L145.85 89.13L136 83.42V83.81L145.66 89.46Z",
    fill: "url(#paint42_linear_318_154)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M143.94 91.61L144.21 91.34L136 86.59V86.98L143.94 91.61Z",
    fill: "url(#paint43_linear_318_154)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M141.65 93.3801L141.94 93.2001L136 89.7601V90.0701L141.65 93.3801Z",
    fill: "url(#paint44_linear_318_154)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.06 77.68L145.87 77.36L136.01 83.03L136.35 83.22L146.06 77.68Z",
    fill: "url(#paint45_linear_318_154)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M147.07 80.25L146.97 79.89L138.75 84.61L139.09 84.81L147.07 80.25Z",
    fill: "url(#paint46_linear_318_154)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M147.45 83.12V82.78L141.49 86.2L141.77 86.35L147.45 83.12Z",
    fill: "url(#paint47_linear_318_154)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M136.06 71.45H135.68L135.66 82.83L136 82.63L136.06 71.45Z",
    fill: "url(#paint48_linear_318_154)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.79 71.86L138.42 71.76L138.4 81.25L138.75 81.05L138.79 71.86Z",
    fill: "url(#paint49_linear_318_154)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M141.46 72.96L141.17 72.8L141.15 79.66L141.42 79.5L141.46 72.96Z",
    fill: "url(#paint50_linear_318_154)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M125.67 76.99L125.49 77.32L135.33 83.03V82.64L125.67 76.99Z",
    fill: "url(#paint51_linear_318_154)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M127.39 74.83L127.12 75.1L135.33 79.86V79.46L127.39 74.83Z",
    fill: "url(#paint52_linear_318_154)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M129.68 73.07L129.39 73.24L135.33 76.69V76.38L129.68 73.07Z",
    fill: "url(#paint53_linear_318_154)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 76.4C126.78 76.4 133.8 80.27 135.08 81.16C135.08 81.16 129.48 78.13 126.78 76.4Z",
    fill: "url(#paint54_linear_318_154)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M128.82 74.42C128.82 74.42 132.93 76.63 135.05 77.96C135.05 77.96 131.52 76.15 128.82 74.42Z",
    fill: "url(#paint55_linear_318_154)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M131.32 72.63C131.32 72.63 132.93 73.47 135.05 74.8C135.05 74.8 133.81 74.24 131.32 72.63Z",
    fill: "url(#paint56_linear_318_154)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M137.08 72.07C137.08 72.07 137.24 80.09 137.11 81.64C137.11 81.64 136.93 75.27 137.08 72.07Z",
    fill: "url(#paint57_linear_318_154)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M139.82 72.83C139.82 72.83 139.96 77.5 139.87 79.99C139.87 79.99 139.68 76.03 139.82 72.83Z",
    fill: "url(#paint58_linear_318_154)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M142.62 74.1C142.62 74.1 142.7 75.91 142.61 78.41C142.61 78.41 142.47 77.06 142.62 74.1Z",
    fill: "url(#paint59_linear_318_154)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M125.37 87.5C125.37 87.5 132.23 83.35 133.64 82.69C133.64 82.69 128.21 86.03 125.37 87.5Z",
    fill: "url(#paint60_linear_318_154)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M124.67 84.75C124.67 84.75 128.64 82.29 130.85 81.13C130.85 81.13 127.52 83.28 124.67 84.75Z",
    fill: "url(#paint61_linear_318_154)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M124.37 81.68C124.37 81.68 125.9 80.7 128.11 79.54C128.11 79.54 127.01 80.33 124.37 81.68Z",
    fill: "url(#paint62_linear_318_154)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M134.26 94.24C134.26 94.24 134.11 88.43 134.23 84.67C134.23 84.67 134.41 91.04 134.26 94.24Z",
    fill: "url(#paint63_linear_318_154)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M131.52 93.47C131.52 93.47 131.38 88.8 131.47 86.31C131.47 86.31 131.66 90.27 131.52 93.47Z",
    fill: "url(#paint64_linear_318_154)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M128.72 92.2C128.72 92.2 128.64 90.39 128.73 87.89C128.73 87.89 128.87 89.24 128.72 92.2Z",
    fill: "url(#paint65_linear_318_154)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M144.47 89.94C144.47 89.94 139.37 87.16 136.17 85.18C136.17 85.18 141.77 88.21 144.47 89.94Z",
    fill: "url(#paint66_linear_318_154)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M142.43 91.92C142.43 91.92 138.32 89.71 136.2 88.38C136.2 88.38 139.73 90.19 142.43 91.92Z",
    fill: "url(#paint67_linear_318_154)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M139.93 93.71C139.93 93.71 138.32 92.87 136.2 91.54C136.2 91.54 137.44 92.1 139.93 93.71Z",
    fill: "url(#paint68_linear_318_154)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M146.07 78.85C146.07 78.85 141.11 81.88 137.8 83.66C137.8 83.66 143.22 80.32 146.07 78.85Z",
    fill: "url(#paint69_linear_318_154)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M146.77 81.61C146.77 81.61 142.8 84.07 140.59 85.23C140.59 85.23 143.92 83.08 146.77 81.61Z",
    fill: "url(#paint70_linear_318_154)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M147.07 84.67C147.07 84.67 145.54 85.65 143.33 86.81C143.33 86.81 144.43 86.02 147.07 84.67Z",
    fill: "url(#paint71_linear_318_154)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M128.36 90.29L130.53 89.04V86.58L128.36 87.83V90.29Z",
    fill: "url(#paint72_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M131.1 88.71L133.27 87.46V85L131.1 86.25V88.71Z",
    fill: "url(#paint73_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M133.84 84.67V87.13L135.66 86.07V83.62L133.84 84.67Z",
    fill: "url(#paint74_linear_318_154)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M138.13 93.08V90.57L136 89.35V91.86L138.13 93.08Z",
    fill: "url(#paint75_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M138.13 89.92V87.41L136 86.19V88.69L138.13 89.92Z",
    fill: "url(#paint76_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M136 85.53L138.13 86.76V84.65L136 83.42V85.53Z",
    fill: "url(#paint77_linear_318_154)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M145.44 86.01L143.27 84.76L141.14 85.99L143.31 87.24L145.44 86.01Z",
    fill: "url(#paint78_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M142.7 84.43L140.53 83.18L138.4 84.41L140.57 85.66L142.7 84.43Z",
    fill: "url(#paint79_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M137.84 84.08L139.97 82.85L138.14 81.8L136.01 83.03L137.84 84.08Z",
    fill: "url(#paint80_linear_318_154)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M142.97 76.16L140.8 77.41V79.87L142.97 78.61V76.16Z",
    fill: "url(#paint81_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M140.23 77.74L138.06 78.99V81.45L140.23 80.2V77.74Z",
    fill: "url(#paint82_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M137.49 81.7799V79.3199L135.67 80.3699V82.8299L137.49 81.7799Z",
    fill: "url(#paint83_linear_318_154)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M133.2 73.36V75.87L135.33 77.1V74.59L133.2 73.36Z",
    fill: "url(#paint84_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M133.2 76.53V79.03L135.33 80.26V77.76L133.2 76.53Z",
    fill: "url(#paint85_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M135.33 80.92L133.2 79.69V81.8L135.33 83.02V80.92Z",
    fill: "url(#paint86_linear_318_154)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M125.89 80.43L128.06 81.69L130.19 80.46L128.02 79.2L125.89 80.43Z",
    fill: "url(#paint87_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M128.63 82.02L130.8 83.27L132.93 82.04L130.76 80.79L128.63 82.02Z",
    fill: "url(#paint88_linear_318_154)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55,
    d: "M133.5 82.3699L131.37 83.5999L133.19 84.6499L135.32 83.4199L133.5 82.3699Z",
    fill: "url(#paint89_linear_318_154)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.07 9.78998C31.36 7.81998 27.9 6.83998 23.68 6.83998C21.97 6.83998 20.29 7.00998 18.63 7.34998C16.98 7.68998 15.51 8.25998 14.23 9.05998C12.95 9.85998 11.92 10.93 11.15 12.27C10.38 13.61 10 15.28 10 17.27C10 19.15 10.55 20.68 11.67 21.84C12.78 23.01 14.26 23.96 16.12 24.7C17.97 25.44 20.07 26.05 22.4 26.54C24.74 27.02 27.12 27.55 29.54 28.12C31.96 28.69 34.34 29.36 36.68 30.13C39.02 30.9 41.11 31.94 42.96 33.25C44.81 34.56 46.29 36.21 47.41 38.21C48.52 40.21 49.08 42.71 49.08 45.73C49.08 48.98 48.35 51.76 46.9 54.07C45.45 56.38 43.58 58.26 41.3 59.71C39.02 61.16 36.47 62.22 33.65 62.87C30.83 63.52 28.02 63.85 25.23 63.85C21.81 63.85 18.57 63.42 15.53 62.57C12.48 61.72 9.80001 60.42 7.49001 58.68C5.18001 56.94 3.36001 54.72 2.02001 52.01C0.68001 49.3 0.0100098 46.1 0.0100098 42.39H7.70001C7.70001 44.95 8.20001 47.16 9.20001 49.02C10.2 50.87 11.51 52.4 13.13 53.59C14.75 54.79 16.65 55.67 18.82 56.24C20.99 56.81 23.21 57.09 25.49 57.09C27.31 57.09 29.15 56.92 31 56.58C32.85 56.24 34.52 55.65 36 54.83C37.48 54 38.68 52.88 39.59 51.45C40.5 50.03 40.96 48.2 40.96 45.98C40.96 43.87 40.41 42.16 39.29 40.85C38.18 39.54 36.7 38.47 34.85 37.64C33 36.81 30.9 36.14 28.57 35.63C26.23 35.12 23.85 34.59 21.43 34.05C19.01 33.51 16.63 32.88 14.29 32.17C11.95 31.46 9.86001 30.52 8.01001 29.35C6.16001 28.18 4.68001 26.67 3.56001 24.82C2.45001 22.97 1.89001 20.65 1.89001 17.85C1.89001 14.77 2.52001 12.11 3.77001 9.85998C5.02001 7.60998 6.69001 5.75998 8.77001 4.29998C10.85 2.83998 13.22 1.75998 15.87 1.04998C18.52 0.33998 21.24 -0.0200195 24.04 -0.0200195C27.17 -0.0200195 30.08 0.34998 32.76 1.08998C35.44 1.82998 37.79 2.99998 39.81 4.59998C41.83 6.19998 43.43 8.20998 44.6 10.63C45.77 13.05 46.41 15.94 46.52 19.31H38.83C38.37 14.92 36.79 11.74 34.09 9.77998L34.07 9.78998Z",
    fill: "#002FA7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M190.33 19.53C191.7 15.63 193.66 12.22 196.23 9.30999C198.79 6.39999 201.94 4.11999 205.68 2.46999C209.41 0.81999 213.62 -0.0100098 218.29 -0.0100098C222.96 -0.0100098 227.24 0.81999 230.94 2.46999C234.64 4.11999 237.78 6.39999 240.34 9.30999C242.9 12.22 244.87 15.62 246.24 19.53C247.61 23.43 248.29 27.67 248.29 32.23C248.29 36.79 247.61 40.82 246.24 44.67C244.87 48.52 242.91 51.87 240.34 54.72C237.77 57.57 234.64 59.81 230.94 61.43C227.23 63.05 223.02 63.87 218.29 63.87C213.56 63.87 209.41 63.06 205.68 61.43C201.95 59.81 198.8 57.57 196.23 54.72C193.67 51.87 191.7 48.52 190.33 44.67C188.96 40.82 188.28 36.68 188.28 32.23C188.28 27.78 188.96 23.44 190.33 19.53ZM202.6 39.71C203.2 42.13 204.15 44.31 205.46 46.25C206.77 48.19 208.48 49.74 210.59 50.91C212.7 52.08 215.26 52.66 218.28 52.66C221.3 52.66 223.86 52.08 225.97 50.91C228.08 49.74 229.79 48.19 231.1 46.25C232.41 44.31 233.36 42.13 233.96 39.71C234.56 37.29 234.86 34.79 234.86 32.23C234.86 29.67 234.56 26.96 233.96 24.45C233.36 21.94 232.41 19.7 231.1 17.74C229.79 15.77 228.08 14.21 225.97 13.04C223.86 11.87 221.3 11.29 218.28 11.29C215.26 11.29 212.69 11.88 210.59 13.04C208.48 14.21 206.77 15.78 205.46 17.74C204.15 19.71 203.19 21.94 202.6 24.45C202 26.96 201.7 29.55 201.7 32.23C201.7 34.91 202 37.29 202.6 39.71Z",
    fill: "#002FA7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M130.35 1.44995H145.4L159.68 25.5599L173.87 1.44995H188.83L166.17 39.07V62.49H152.75V38.72L130.35 1.44995Z",
    fill: "#002FA7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M54.97 31.33C55.88 28.51 57.25 26.06 59.07 23.98C60.89 21.9 63.14 20.26 65.82 19.06C68.5 17.86 71.58 17.27 75.05 17.27C78.52 17.27 81.68 17.87 84.33 19.06C86.98 20.26 89.22 21.9 91.04 23.98C92.86 26.06 94.23 28.51 95.14 31.33C96.05 34.15 96.51 37.19 96.51 40.43C96.51 43.67 96.05 46.7 95.14 49.49C94.23 52.28 92.86 54.72 91.04 56.8C89.22 58.88 86.98 60.5 84.33 61.67C81.68 62.84 78.59 63.42 75.05 63.42C71.51 63.42 68.49 62.83 65.82 61.67C63.14 60.5 60.89 58.88 59.07 56.8C57.24 54.72 55.88 52.28 54.97 49.49C54.06 46.7 53.6 43.68 53.6 40.43C53.6 37.18 54.06 34.15 54.97 31.33ZM62.37 47.57C63.08 49.65 64.07 51.39 65.32 52.78C66.57 54.18 68.04 55.25 69.72 55.99C71.4 56.73 73.18 57.1 75.06 57.1C76.94 57.1 78.72 56.73 80.4 55.99C82.08 55.25 83.55 54.18 84.8 52.78C86.05 51.38 87.03 49.65 87.75 47.57C88.46 45.49 88.82 43.11 88.82 40.43C88.82 37.75 88.46 35.37 87.75 33.29C87.04 31.21 86.05 29.46 84.8 28.03C83.55 26.61 82.08 25.52 80.4 24.78C78.72 24.04 76.94 23.67 75.06 23.67C73.18 23.67 71.4 24.04 69.72 24.78C68.04 25.52 66.57 26.6 65.32 28.03C64.07 29.46 63.08 31.21 62.37 33.29C61.66 35.37 61.3 37.75 61.3 40.43C61.3 43.11 61.65 45.49 62.37 47.57Z",
    fill: "#002FA7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M132.47 17.76L119.85 54.46H119.68L106.77 18.3H98.56L116.09 62.24L113.1 69.68C112.59 70.99 111.83 72 110.83 72.72C109.83 73.43 108.59 73.79 107.11 73.79C106.54 73.79 105.84 73.69 105.02 73.49C104.19 73.29 103.47 73.05 102.84 72.76V79.43C103.64 79.71 104.46 79.91 105.32 80.03C106.18 80.14 107.03 80.2 107.88 80.2C109.48 80.2 110.89 79.99 112.11 79.56C113.34 79.13 114.45 78.45 115.44 77.51C116.44 76.57 117.35 75.36 118.18 73.88C119.01 72.4 119.85 70.57 120.7 68.41L137.15 25.58L132.46 17.78L132.47 17.76Z",
    fill: "#002FA7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M108.46 94.82V93.66H108.43C108.2 94.13 107.83 94.48 107.34 94.69C106.84 94.9 106.3 95 105.7 95C105.04 95 104.46 94.88 103.97 94.64C103.48 94.4 103.07 94.07 102.75 93.66C102.42 93.25 102.18 92.78 102.01 92.24C101.85 91.7 101.76 91.13 101.76 90.52C101.76 89.91 101.84 89.34 102 88.8C102.16 88.26 102.4 87.79 102.73 87.38C103.05 86.98 103.46 86.66 103.95 86.42C104.44 86.18 105.01 86.06 105.66 86.06C105.88 86.06 106.12 86.08 106.37 86.13C106.62 86.17 106.88 86.25 107.13 86.35C107.38 86.45 107.62 86.59 107.85 86.76C108.08 86.93 108.27 87.14 108.42 87.4H108.45V83H109.86V94.82H108.45H108.46ZM103.4 91.78C103.5 92.16 103.67 92.5 103.88 92.8C104.1 93.1 104.37 93.34 104.71 93.51C105.05 93.69 105.44 93.77 105.89 93.77C106.36 93.77 106.77 93.68 107.1 93.49C107.43 93.3 107.7 93.06 107.91 92.75C108.12 92.45 108.27 92.1 108.37 91.72C108.46 91.33 108.51 90.94 108.51 90.54C108.51 90.12 108.46 89.72 108.36 89.32C108.26 88.92 108.1 88.58 107.89 88.29C107.68 88 107.4 87.75 107.05 87.57C106.71 87.39 106.29 87.3 105.81 87.3C105.33 87.3 104.93 87.39 104.6 87.58C104.27 87.77 104 88.02 103.81 88.33C103.62 88.64 103.47 88.99 103.38 89.39C103.29 89.79 103.25 90.2 103.25 90.61C103.25 91.02 103.3 91.4 103.41 91.78H103.4Z",
    fill: "#0033A1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M117.76 94.27C117.12 94.76 116.31 95 115.34 95C114.66 95 114.06 94.89 113.56 94.67C113.06 94.45 112.64 94.14 112.29 93.74C111.95 93.34 111.69 92.87 111.52 92.32C111.35 91.77 111.25 91.17 111.23 90.52C111.23 89.87 111.33 89.27 111.53 88.73C111.73 88.19 112.01 87.72 112.37 87.32C112.73 86.92 113.15 86.61 113.64 86.39C114.13 86.17 114.67 86.06 115.25 86.06C116.01 86.06 116.64 86.22 117.15 86.53C117.66 86.84 118.05 87.24 118.36 87.73C118.66 88.22 118.87 88.75 118.99 89.32C119.11 89.89 119.15 90.44 119.13 90.96H112.72C112.71 91.34 112.75 91.69 112.85 92.03C112.95 92.37 113.11 92.66 113.33 92.92C113.55 93.18 113.83 93.39 114.17 93.54C114.51 93.69 114.91 93.77 115.38 93.77C115.97 93.77 116.46 93.63 116.84 93.36C117.22 93.08 117.47 92.67 117.59 92.1H118.98C118.79 93.06 118.38 93.78 117.74 94.27H117.76ZM117.42 88.77C117.29 88.47 117.12 88.22 116.91 88C116.7 87.78 116.44 87.61 116.15 87.49C115.86 87.36 115.53 87.3 115.18 87.3C114.83 87.3 114.49 87.36 114.2 87.49C113.91 87.62 113.66 87.79 113.45 88.01C113.24 88.23 113.07 88.49 112.95 88.78C112.83 89.07 112.76 89.38 112.73 89.72H117.65C117.63 89.39 117.55 89.07 117.43 88.78L117.42 88.77Z",
    fill: "#0033A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_154",
    x1: 134.67,
    y1: 83.61,
    x2: 134.78,
    y2: 90.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#881821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2211D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_154",
    x1: 131.95,
    y1: 85.2,
    x2: 132.04,
    y2: 91.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#881821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2211D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_154",
    x1: 129.23,
    y1: 86.79,
    x2: 129.3,
    y2: 91.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#881821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2211D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_154",
    x1: 135.81,
    y1: 83.58,
    x2: 135.86,
    y2: 94.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87181C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B42227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2211D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_154",
    x1: 133.07,
    y1: 85.3,
    x2: 133.12,
    y2: 94.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87181C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B42227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2211D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_154",
    x1: 130.34,
    y1: 86.8,
    x2: 130.37,
    y2: 93.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87181C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B42227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2211D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_154",
    x1: 135.425,
    y1: 84.2379,
    x2: 144.823,
    y2: 89.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F29826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_154",
    x1: 135.433,
    y1: 87.3835,
    x2: 140.518,
    y2: 90.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F29826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_154",
    x1: 135.45,
    y1: 90.5341,
    x2: 139.14,
    y2: 92.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F29826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_154",
    x1: 135.996,
    y1: 83.4294,
    x2: 145.816,
    y2: 89.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F29826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_154",
    x1: 136.116,
    y1: 86.6623,
    x2: 144.186,
    y2: 91.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F29826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_154",
    x1: 136.05,
    y1: 89.7765,
    x2: 141.95,
    y2: 93.1369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F29826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_154",
    x1: 136.432,
    y1: 83.7378,
    x2: 142.422,
    y2: 80.1525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1962D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0E304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_154",
    x1: 139.16,
    y1: 85.3034,
    x2: 144.156,
    y2: 82.3155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1962D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0E304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_154",
    x1: 141.897,
    y1: 86.864,
    x2: 145.517,
    y2: 84.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1962D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0E304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_154",
    x1: 135.86,
    y1: 82.9801,
    x2: 145.616,
    y2: 77.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0E304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_154",
    x1: 138.705,
    y1: 84.4894,
    x2: 146.726,
    y2: 79.8011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0E304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_154",
    x1: 141.369,
    y1: 86.1036,
    x2: 147.243,
    y2: 82.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0E304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_154",
    x1: 136.67,
    y1: 82.83,
    x2: 136.56,
    y2: 75.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9BC11D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_318_154",
    x1: 139.39,
    y1: 81.25,
    x2: 139.3,
    y2: 75.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9BC11D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_318_154",
    x1: 142.11,
    y1: 79.66,
    x2: 142.04,
    y2: 75.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9BC11D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_154",
    x1: 135.53,
    y1: 82.86,
    x2: 135.47,
    y2: 71.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BC11A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_154",
    x1: 138.26,
    y1: 81.15,
    x2: 138.21,
    y2: 71.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BC11A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_318_154",
    x1: 140.99,
    y1: 79.65,
    x2: 140.96,
    y2: 72.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BC11A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_318_154",
    x1: 135.734,
    y1: 82.2956,
    x2: 129.634,
    y2: 78.9009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#28347C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_318_154",
    x1: 135.726,
    y1: 79.15,
    x2: 130.64,
    y2: 76.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#28347C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_318_154",
    x1: 135.704,
    y1: 76.0081,
    x2: 132.019,
    y2: 73.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#28347C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_318_154",
    x1: 135.173,
    y1: 83.1042,
    x2: 125.348,
    y2: 77.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2D63AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28347C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_318_154",
    x1: 135.048,
    y1: 79.8799,
    x2: 126.983,
    y2: 75.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2D63AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28347C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_318_154",
    x1: 135.114,
    y1: 76.7656,
    x2: 129.219,
    y2: 73.3966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2D63AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28347C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_318_154",
    x1: 134.728,
    y1: 82.5985,
    x2: 128.738,
    y2: 86.1838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E112E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#181833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_318_154",
    x1: 132,
    y1: 81.033,
    x2: 127.005,
    y2: 84.0209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E112E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#181833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_318_154",
    x1: 129.268,
    y1: 79.481,
    x2: 125.643,
    y2: 81.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E112E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#181833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_318_154",
    x1: 135.306,
    y1: 83.3748,
    x2: 125.545,
    y2: 89.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#29112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_318_154",
    x1: 132.455,
    y1: 81.8569,
    x2: 124.434,
    y2: 86.5452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#29112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_318_154",
    x1: 124.64,
    y1: 83.42,
    x2: 130.14,
    y2: 80.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#29112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_318_154",
    x1: 134.942,
    y1: 83.1286,
    x2: 125.226,
    y2: 88.8192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36163C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#752D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822F85",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_318_154",
    x1: 132.24,
    y1: 81.548,
    x2: 124.133,
    y2: 86.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36163C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#752D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822F85",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_318_154",
    x1: 129.539,
    y1: 79.9897,
    x2: 123.678,
    y2: 83.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36163C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#752D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822F85",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_318_154",
    x1: 135.44,
    y1: 83.78,
    x2: 135.5,
    y2: 95.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2261F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_318_154",
    x1: 132.71,
    y1: 85.33,
    x2: 132.76,
    y2: 94.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2261F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_318_154",
    x1: 130.02,
    y1: 86.89,
    x2: 130.05,
    y2: 93.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2261F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_318_154",
    x1: 136,
    y1: 83.8817,
    x2: 145.781,
    y2: 89.4597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABE16",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7E625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABE16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_318_154",
    x1: 135.977,
    y1: 87.0209,
    x2: 144.134,
    y2: 91.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABE16",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7E625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABE16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_318_154",
    x1: 135.969,
    y1: 90.1342,
    x2: 141.87,
    y2: 93.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABE16",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7E625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABE16",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_318_154",
    x1: 136.217,
    y1: 83.2201,
    x2: 145.938,
    y2: 77.5381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E724",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_318_154",
    x1: 138.924,
    y1: 84.8094,
    x2: 147.031,
    y2: 80.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E724",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_318_154",
    x1: 141.622,
    y1: 86.3813,
    x2: 147.482,
    y2: 82.9516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E724",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_318_154",
    x1: 135.89,
    y1: 82.67,
    x2: 135.83,
    y2: 71.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D233",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EBE103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D233",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_318_154",
    x1: 138.62,
    y1: 81.11,
    x2: 138.57,
    y2: 71.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D233",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EBE103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D233",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_318_154",
    x1: 141.32,
    y1: 79.56,
    x2: 141.28,
    y2: 72.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D233",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EBE103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D233",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_318_154",
    x1: 135.187,
    y1: 82.6845,
    x2: 125.406,
    y2: 77.1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065BA5",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#065BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065BA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_318_154",
    x1: 135.21,
    y1: 79.5453,
    x2: 127.053,
    y2: 74.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065BA5",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#065BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065BA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_318_154",
    x1: 135.218,
    y1: 76.432,
    x2: 129.322,
    y2: 73.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065BA5",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#065BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#065BA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_318_154",
    x1: 135.1,
    y1: 81.13,
    x2: 126.73,
    y2: 76.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_318_154",
    x1: 135.06,
    y1: 78,
    x2: 128.85,
    y2: 74.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_318_154",
    x1: 135.07,
    y1: 74.8,
    x2: 131.36,
    y2: 72.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_318_154",
    x1: 137.037,
    y1: 81.6959,
    x2: 136.923,
    y2: 72.0973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_318_154",
    x1: 139.723,
    y1: 80.0876,
    x2: 139.715,
    y2: 72.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_318_154",
    x1: 142.504,
    y1: 78.5049,
    x2: 142.485,
    y2: 74.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A8E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_318_154",
    x1: 133.523,
    y1: 82.5865,
    x2: 125.263,
    y2: 87.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A173D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A173D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_318_154",
    x1: 130.788,
    y1: 81.0648,
    x2: 124.591,
    y2: 84.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A173D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A173D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_318_154",
    x1: 128.035,
    y1: 79.4524,
    x2: 124.339,
    y2: 81.6141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A173D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A173D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_318_154",
    x1: 134.102,
    y1: 84.4805,
    x2: 134.217,
    y2: 94.0791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22329",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22329",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_318_154",
    x1: 131.411,
    y1: 86.0801,
    x2: 131.425,
    y2: 93.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22329",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22329",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_318_154",
    x1: 128.635,
    y1: 87.6715,
    x2: 128.654,
    y2: 91.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22329",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22329",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_318_154",
    x1: 136.15,
    y1: 85.21,
    x2: 144.52,
    y2: 89.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29921",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29921",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_318_154",
    x1: 136.2,
    y1: 88.34,
    x2: 142.4,
    y2: 91.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29921",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29921",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_318_154",
    x1: 136.18,
    y1: 91.53,
    x2: 139.89,
    y2: 93.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29921",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29921",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_318_154",
    x1: 137.686,
    y1: 83.869,
    x2: 145.942,
    y2: 78.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E320",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_318_154",
    x1: 140.422,
    y1: 85.3907,
    x2: 146.614,
    y2: 81.8063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E320",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_318_154",
    x1: 143.175,
    y1: 87.003,
    x2: 146.874,
    y2: 84.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0E320",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_318_154",
    x1: 129.45,
    y1: 87.35,
    x2: 129.45,
    y2: 89.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_318_154",
    x1: 132.19,
    y1: 85.71,
    x2: 132.19,
    y2: 87.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_318_154",
    x1: 134.75,
    y1: 84.26,
    x2: 134.75,
    y2: 85.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_318_154",
    x1: 136.041,
    y1: 90.6108,
    x2: 137.574,
    y2: 91.4958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_318_154",
    x1: 136,
    y1: 87.4229,
    x2: 137.585,
    y2: 88.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_318_154",
    x1: 136.024,
    y1: 84.4809,
    x2: 137.505,
    y2: 85.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_318_154",
    x1: 142.27,
    y1: 86.384,
    x2: 143.803,
    y2: 85.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_318_154",
    x1: 139.489,
    y1: 84.8261,
    x2: 141.074,
    y2: 83.9111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_318_154",
    x1: 136.944,
    y1: 83.339,
    x2: 138.434,
    y2: 82.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_318_154",
    x1: 141.88,
    y1: 79.1,
    x2: 141.88,
    y2: 77.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_318_154",
    x1: 139.14,
    y1: 80.74,
    x2: 139.14,
    y2: 78.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_318_154",
    x1: 136.58,
    y1: 82.1899,
    x2: 136.58,
    y2: 80.4799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_318_154",
    x1: 135.115,
    y1: 75.9254,
    x2: 133.574,
    y2: 75.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_318_154",
    x1: 135.157,
    y1: 79.1133,
    x2: 133.572,
    y2: 78.1983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_318_154",
    x1: 135.133,
    y1: 82.0553,
    x2: 133.652,
    y2: 81.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_318_154",
    x1: 128.89,
    y1: 79.9463,
    x2: 127.357,
    y2: 80.8313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_318_154",
    x1: 131.672,
    y1: 81.5042,
    x2: 130.087,
    y2: 82.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_318_154",
    x1: 134.212,
    y1: 83.0048,
    x2: 132.731,
    y2: 83.8598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248.29,
    height: 95,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoyYo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SoyYo.e61a63c2c12bf546421989f706029d6a.svg";